<template>
  <div class="container justify-content-center mt-5">
    <div
      class="
        row
        d-flex
        justify-content-center
        company-product-payment-success-page
      "
    >
      <div class="col-md-8 mt-3">
        <h3 class="text-center mb-4 page-title">{{ $t(LangConstants.thanks_for_order_heading) }}</h3>
        <p class="mb-5 text-center page-desc">
          {{ $t(LangConstants.order_confirmation_mail_sent_text) }}
        </p>

        <div class="row form-base order-info-entitites pl-3 pr-3 mb-4">
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.order_number_text) }}</span>
            <span class="value">{{ this.orderNumber }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.product_text) }}</span>
            <span class="value">{{ productName }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.total_cost_text) }}</span>
            <span class="value">{{ this.totalCost }}</span>
          </div>
        </div>

        <div class="row form-base pl-3 pr-3 mb-4 redirect-home">
          <div class="col-md-12 order-info-entity mb-4">
            <div class="row">
              <div class="col-auto">
                <i class="fa fa-building" aria-hidden="true"></i>
              </div>
              <div class="col text">
                {{ $t(LangConstants.customer_pages_heading) }}
                <div class="description">
                  {{ $t(LangConstants.customer_pages_text) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="mb-2">
              <my-button fa="" :label="$t(LangConstants.contact_us_button_label)" variant="box-primary" classes="mr-1" height="64px" minwidth="400px" @onClick="onclick"></my-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Webshop Payment Success Page
 */
import "../../../../assets/scss/companyproductpaymentsuccesspage.scss";
import MyButton from "../../../../components/atoms/Button.vue";
import common from "../../../../functions/index";
// import Csrf from "../../../../apis/Csrf";
import Constants from "../../../../constants/index";

export default {
  name: "webshop-payment-success",
  async created() {
    try {
      const self = this;
      let formData = common.getFromLocalStorage(this.$route.params.id);

      const trType = this.$route.params.type;
      this.subscriptionId = null;

      switch (trType) {
        case "card":
          {
            this.handleStripeCardPayment(self, formData, trType);
          }
          break;
      }
    } catch (error) {
      this.$fire({
        title: this.$t(this.LangConstants.error_retrieving_subscription_heading),
        text: this.$t(this.LangConstants.stripe_api_error_text),
        type: "error",
        html: "",
      });
    }
  },

  methods: {
    onclick() {
      window.open("https://sparkfore.com/", "_blank").focus();
    },

    async handleStripeCardPayment(self, formData, trType) {
      let sessData = await this.$store.dispatch("getStripeCheckoutSession", { id: this.$route.params.id, connectedAccount: this.$route.params.connectedAccount });

      sessData = JSON.parse(JSON.stringify(sessData));
      // this.subdomain = sessData["metadata"]["subdomain"];
      this.productName = sessData["metadata"]["product"];
      this.paymentIntent = await this.$store.dispatch("getStripePaymentIntent", { id: sessData["payment_intent"], StripeAccount: this.$route.params.connectedAccount });
      let amount = this.paymentIntent.data.charges.data[0].amount / 100;
      this.totalCost = parseFloat(amount).toFixed(2) + " " + this.paymentIntent.data.charges.data[0].currency;
      this.chargeId = this.paymentIntent.data.charges.data[0].id;
      this.orderNumber = this.paymentIntent.data.id;

      let updatePayload = {
        id: formData.webshop_payment_id,
        webshop_payment: {
          return_log: JSON.stringify(this.paymentIntent),
          date_paid: this.paymentIntent.data.charges.data[0].created,
          status: "success",
          method: trType,
        },
        has_suspended_participants : true,
      };

      let chargePayload = {
        charge: {
          web_shop_payment_id: formData.webshop_payment_id,
          // 'user_id' => $webshop_payment_payload['user_id'], web_shop_payment_id
          instance_id: formData.instance_id,
          charge_id: this.chargeId,
          response: JSON.stringify(this.paymentIntent.data),
        },
      };

      await this.updateWebShopPayment(updatePayload);
      await this.$store.dispatch("createWebshopPaymentCharge", JSON.stringify(chargePayload));

      if (this.chargeId == null || !this.chargeId) {
        this.$fire({
          title: this.$t(this.LangConstants.error_retrieving_subscription_heading),
          text: this.$t(this.LangConstants.no_subscription_id_message),
          type: "error",
          html: "",
        });
      }
    },

    async updateWebShopPayment(payload) {
      try {
        let payment = await this.$store.dispatch("updateWebshopPayment", payload);
        if (payment) {
          await this.$fire({
            title: this.$t(this.LangConstants.payment_successful),
            type: "success",
            timer: 6000,
          });
        }
      } catch (error) {
        this.$fire({
          title: this.$t(this.LangConstants.subscription_status_error_heading),
          text: this.$t(this.LangConstants.create_webshop_payment_failed_text),
          type: "error",
          html: "<div>" + this.$t(error) + "</div>",
        });
      }
    },
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  data() {
    return {
      productName: "",
      productInterval: "",
      orderNumber: "",
      // subdomain: null,
      totalCost: "",
      subscriptionId: null,
      moodleUserId: null,
      lmsUrl: null,
      chargeId: null,
      paymentIntent: null,
      payment: null,
      paymentId: null,
      userType: "",
      discount: 0,
      formData: {},
    };
  },
  components: {
    MyButton,
  },
};
</script>
